export default __webpack_public_path__ + "static/media/invite_org_to_coalition.51e882df.svg";